export const heightVariants = {
  height: {
    0: 'h-0',
    px: 'h-px',
    '0.5': 'h-0.5',
    1: 'h-1',
    '1.5': 'h-1.5',
    2: 'h-2',
    '2.5': 'h-2.5',
    3: 'h-3',
    '3.5': 'h-3.5',
    4: 'h-4',
    5: 'h-5',
    6: 'h-6',
    7: 'h-7',
    8: 'h-8',
    9: 'h-9',
    10: 'h-10',
    11: 'h-11',
    12: 'h-12',
    14: 'h-14',
    16: 'h-16',
    20: 'h-20',
    24: 'h-24',
    28: 'h-28',
    32: 'h-32',
    36: 'h-36',
    40: 'h-40',
    44: 'h-44',
    48: 'h-48',
    52: 'h-52',
    56: 'h-56',
    60: 'h-60',
    64: 'h-64',
    72: 'h-72',
    80: 'h-80',
    96: 'h-96',
    auto: 'h-auto',
    '1/2': 'h-1/2',
    '1/3': 'h-1/3',
    '2/3': 'h-2/3',
    '1/4': 'h-1/4',
    '2/4': 'h-2/4',
    '3/4': 'h-3/4',
    '1/5': 'h-1/5',
    '2/5': 'h-2/5',
    '3/5': 'h-3/5',
    '4/5': 'h-4/5',
    '1/6': 'h-1/6',
    '2/6': 'h-2/6',
    '3/6': 'h-3/6',
    '4/6': 'h-4/6',
    '5/6': 'h-5/6',
    '1/12': 'h-1/12',
    '2/12': 'h-2/12',
    '3/12': 'h-3/12',
    '4/12': 'h-4/12',
    '5/12': 'h-5/12',
    '6/12': 'h-6/12',
    '7/12': 'h-7/12',
    '8/12': 'h-8/12',
    '9/12': 'h-9/12',
    '10/12': 'h-10/12',
    '11/12': 'h-11/12',
    full: 'h-full',
    screen: 'h-screen',
    svh: 'h-svh',
    lvh: 'h-lvh',
    dvh: 'h-dvh',
    min: 'h-min',
    max: 'h-max',
    fit: 'h-fit',
  },
  'height-sm': {
    0: 'sm:h-0',
    px: 'sm:h-px',
    '0.5': 'sm:h-0.5',
    1: 'sm:h-1',
    '1.5': 'sm:h-1.5',
    2: 'sm:h-2',
    '2.5': 'sm:h-2.5',
    3: 'sm:h-3',
    '3.5': 'sm:h-3.5',
    4: 'sm:h-4',
    5: 'sm:h-5',
    6: 'sm:h-6',
    7: 'sm:h-7',
    8: 'sm:h-8',
    9: 'sm:h-9',
    10: 'sm:h-10',
    11: 'sm:h-11',
    12: 'sm:h-12',
    14: 'sm:h-14',
    16: 'sm:h-16',
    20: 'sm:h-20',
    24: 'sm:h-24',
    28: 'sm:h-28',
    32: 'sm:h-32',
    36: 'sm:h-36',
    40: 'sm:h-40',
    44: 'sm:h-44',
    48: 'sm:h-48',
    52: 'sm:h-52',
    56: 'sm:h-56',
    60: 'sm:h-60',
    64: 'sm:h-64',
    72: 'sm:h-72',
    80: 'sm:h-80',
    96: 'sm:h-96',
    auto: 'sm:h-auto',
    '1/2': 'sm:h-1/2',
    '1/3': 'sm:h-1/3',
    '2/3': 'sm:h-2/3',
    '1/4': 'sm:h-1/4',
    '2/4': 'sm:h-2/4',
    '3/4': 'sm:h-3/4',
    '1/5': 'sm:h-1/5',
    '2/5': 'sm:h-2/5',
    '3/5': 'sm:h-3/5',
    '4/5': 'sm:h-4/5',
    '1/6': 'sm:h-1/6',
    '2/6': 'sm:h-2/6',
    '3/6': 'sm:h-3/6',
    '4/6': 'sm:h-4/6',
    '5/6': 'sm:h-5/6',
    '1/12': 'sm:h-1/12',
    '2/12': 'sm:h-2/12',
    '3/12': 'sm:h-3/12',
    '4/12': 'sm:h-4/12',
    '5/12': 'sm:h-5/12',
    '6/12': 'sm:h-6/12',
    '7/12': 'sm:h-7/12',
    '8/12': 'sm:h-8/12',
    '9/12': 'sm:h-9/12',
    '10/12': 'sm:h-10/12',
    '11/12': 'sm:h-11/12',
    full: 'sm:h-full',
    screen: 'sm:h-screen',
    svh: 'sm:h-svh',
    lvh: 'sm:h-lvh',
    dvh: 'sm:h-dvh',
    min: 'sm:h-min',
    max: 'sm:h-max',
    fit: 'sm:h-fit',
  },
  'height-md': {
    0: 'md:h-0',
    px: 'md:h-px',
    '0.5': 'md:h-0.5',
    1: 'md:h-1',
    '1.5': 'md:h-1.5',
    2: 'md:h-2',
    '2.5': 'md:h-2.5',
    3: 'md:h-3',
    '3.5': 'md:h-3.5',
    4: 'md:h-4',
    5: 'md:h-5',
    6: 'md:h-6',
    7: 'md:h-7',
    8: 'md:h-8',
    9: 'md:h-9',
    10: 'md:h-10',
    11: 'md:h-11',
    12: 'md:h-12',
    14: 'md:h-14',
    16: 'md:h-16',
    20: 'md:h-20',
    24: 'md:h-24',
    28: 'md:h-28',
    32: 'md:h-32',
    36: 'md:h-36',
    40: 'md:h-40',
    44: 'md:h-44',
    48: 'md:h-48',
    52: 'md:h-52',
    56: 'md:h-56',
    60: 'md:h-60',
    64: 'md:h-64',
    72: 'md:h-72',
    80: 'md:h-80',
    96: 'md:h-96',
    auto: 'md:h-auto',
    '1/2': 'md:h-1/2',
    '1/3': 'md:h-1/3',
    '2/3': 'md:h-2/3',
    '1/4': 'md:h-1/4',
    '2/4': 'md:h-2/4',
    '3/4': 'md:h-3/4',
    '1/5': 'md:h-1/5',
    '2/5': 'md:h-2/5',
    '3/5': 'md:h-3/5',
    '4/5': 'md:h-4/5',
    '1/6': 'md:h-1/6',
    '2/6': 'md:h-2/6',
    '3/6': 'md:h-3/6',
    '4/6': 'md:h-4/6',
    '5/6': 'md:h-5/6',
    '1/12': 'md:h-1/12',
    '2/12': 'md:h-2/12',
    '3/12': 'md:h-3/12',
    '4/12': 'md:h-4/12',
    '5/12': 'md:h-5/12',
    '6/12': 'md:h-6/12',
    '7/12': 'md:h-7/12',
    '8/12': 'md:h-8/12',
    '9/12': 'md:h-9/12',
    '10/12': 'md:h-10/12',
    '11/12': 'md:h-11/12',
    full: 'md:h-full',
    screen: 'md:h-screen',
    svh: 'md:h-svh',
    lvh: 'md:h-lvh',
    dvh: 'md:h-dvh',
    min: 'md:h-min',
    max: 'md:h-max',
    fit: 'md:h-fit',
  },
  'height-lg': {
    0: 'lg:h-0',
    px: 'lg:h-px',
    '0.5': 'lg:h-0.5',
    1: 'lg:h-1',
    '1.5': 'lg:h-1.5',
    2: 'lg:h-2',
    '2.5': 'lg:h-2.5',
    3: 'lg:h-3',
    '3.5': 'lg:h-3.5',
    4: 'lg:h-4',
    5: 'lg:h-5',
    6: 'lg:h-6',
    7: 'lg:h-7',
    8: 'lg:h-8',
    9: 'lg:h-9',
    10: 'lg:h-10',
    11: 'lg:h-11',
    12: 'lg:h-12',
    14: 'lg:h-14',
    16: 'lg:h-16',
    20: 'lg:h-20',
    24: 'lg:h-24',
    28: 'lg:h-28',
    32: 'lg:h-32',
    36: 'lg:h-36',
    40: 'lg:h-40',
    44: 'lg:h-44',
    48: 'lg:h-48',
    52: 'lg:h-52',
    56: 'lg:h-56',
    60: 'lg:h-60',
    64: 'lg:h-64',
    72: 'lg:h-72',
    80: 'lg:h-80',
    96: 'lg:h-96',
    auto: 'lg:h-auto',
    '1/2': 'lg:h-1/2',
    '1/3': 'lg:h-1/3',
    '2/3': 'lg:h-2/3',
    '1/4': 'lg:h-1/4',
    '2/4': 'lg:h-2/4',
    '3/4': 'lg:h-3/4',
    '1/5': 'lg:h-1/5',
    '2/5': 'lg:h-2/5',
    '3/5': 'lg:h-3/5',
    '4/5': 'lg:h-4/5',
    '1/6': 'lg:h-1/6',
    '2/6': 'lg:h-2/6',
    '3/6': 'lg:h-3/6',
    '4/6': 'lg:h-4/6',
    '5/6': 'lg:h-5/6',
    '1/12': 'lg:h-1/12',
    '2/12': 'lg:h-2/12',
    '3/12': 'lg:h-3/12',
    '4/12': 'lg:h-4/12',
    '5/12': 'lg:h-5/12',
    '6/12': 'lg:h-6/12',
    '7/12': 'lg:h-7/12',
    '8/12': 'lg:h-8/12',
    '9/12': 'lg:h-9/12',
    '10/12': 'lg:h-10/12',
    '11/12': 'lg:h-11/12',
    full: 'lg:h-full',
    screen: 'lg:h-screen',
    svh: 'lg:h-svh',
    lvh: 'lg:h-lvh',
    dvh: 'lg:h-dvh',
    min: 'lg:h-min',
    max: 'lg:h-max',
    fit: 'lg:h-fit',
  },
}

export const fullHeightVariants = {
  fullHeight: {
    true: 'h-full',
    false: null,
  },
}
